const electionData = [
  {
    1976: {
      AK: {
        total: 123574,
        democrat: 35.65,
        republican: 57.9
      },
      AL: {
        total: 1182850,
        democrat: 55.73,
        republican: 42.61
      },
      AR: {
        total: 767535,
        democrat: 64.96,
        republican: 34.9
      },
      AZ: {
        total: 742719,
        democrat: 39.8,
        republican: 56.37
      },
      CA: {
        total: 7803770,
        democrat: 47.95,
        republican: 49.75
      },
      CO: {
        total: 1081440,
        democrat: 42.61,
        republican: 54.03
      },
      CT: {
        total: 1386355,
        democrat: 46.73,
        republican: 51.88
      },
      DC: {
        total: 168830,
        democrat: 81.63,
        republican: 16.51
      },
      DE: {
        total: 235642,
        democrat: 51.97,
        republican: 46.59
      },
      FL: {
        total: 3150631,
        democrat: 51.93,
        republican: 46.64
      },
      GA: {
        total: 1463152,
        democrat: 66.94,
        republican: 33.06
      },
      HI: {
        total: 291301,
        democrat: 50.59,
        republican: 48.06
      },
      IA: {
        total: 1279303,
        democrat: 48.46,
        republican: 49.47
      },
      ID: {
        total: 340932,
        democrat: 37.12,
        republican: 59.88
      },
      IL: {
        total: 4721282,
        democrat: 48.11,
        republican: 50.08
      },
      IN: {
        total: 2220362,
        democrat: 45.7,
        republican: 53.32
      },
      KS: {
        total: 957845,
        democrat: 44.94,
        republican: 52.49
      },
      KY: {
        total: 1167142,
        democrat: 52.75,
        republican: 45.57
      },
      LA: {
        total: 1277383,
        democrat: 51.77,
        republican: 45.99
      },
      MA: {
        total: 2547558,
        democrat: 56.11,
        republican: 40.44
      },
      MD: {
        total: 1432273,
        democrat: 53.04,
        republican: 46.96
      },
      ME: {
        total: 482968,
        democrat: 48.09,
        republican: 48.93
      },
      MI: {
        total: 3651590,
        democrat: 46.47,
        republican: 51.86
      },
      MN: {
        total: 1949931,
        democrat: 54.9,
        republican: 42.02
      },
      MO: {
        total: 1953600,
        democrat: 51.1,
        republican: 47.47
      },
      MS: {
        total: 768390,
        democrat: 49.63,
        republican: 47.74
      },
      MT: {
        total: 328734,
        democrat: 45.4,
        republican: 52.84
      },
      NC: {
        total: 1677906,
        democrat: 55.27,
        republican: 44.22
      },
      ND: {
        total: 297308,
        democrat: 45.77,
        republican: 51.69
      },
      NE: {
        total: 606749,
        democrat: 38.45,
        republican: 59.2
      },
      NH: {
        total: 339627,
        democrat: 43.47,
        republican: 54.75
      },
      NJ: {
        total: 3014472,
        democrat: 47.92,
        republican: 50.08
      },
      NM: {
        total: 416590,
        democrat: 48.28,
        republican: 50.75
      },
      NV: {
        total: 201876,
        democrat: 45.81,
        republican: 50.17
      },
      NY: {
        total: 6668262,
        democrat: 48.65,
        republican: 42.38
      },
      OH: {
        total: 4110456,
        democrat: 48.9,
        republican: 48.67
      },
      OK: {
        total: 1092251,
        democrat: 48.75,
        republican: 49.96
      },
      OR: {
        total: 1029876,
        democrat: 47.62,
        republican: 47.78
      },
      PA: {
        total: 4620787,
        democrat: 50.4,
        republican: 47.73
      },
      RI: {
        total: 410584,
        democrat: 55.44,
        republican: 44.14
      },
      SC: {
        total: 802583,
        democrat: 56.17,
        republican: 43.13
      },
      SD: {
        total: 300678,
        democrat: 48.91,
        republican: 50.39
      },
      TN: {
        total: 1476346,
        democrat: 55.94,
        republican: 42.94
      },
      TX: {
        total: 4071884,
        democrat: 51.14,
        republican: 47.97
      },
      UT: {
        total: 541218,
        democrat: 33.65,
        republican: 62.43
      },
      VA: {
        total: 1697094,
        democrat: 47.96,
        republican: 49.29
      },
      VT: {
        total: 183902,
        democrat: 42.3,
        republican: 54.59
      },
      WA: {
        total: 1555534,
        democrat: 46.11,
        republican: 50.0
      },
      WI: {
        total: 2101336,
        democrat: 49.5,
        republican: 47.83
      },
      WV: {
        total: 750590,
        democrat: 58.07,
        republican: 41.93
      },
      WY: {
        total: 156343,
        democrat: 39.81,
        republican: 59.3
      }
    },
    1980: {
      AK: {
        total: 158445,
        democrat: 26.41,
        republican: 54.35
      },
      AL: {
        total: 1341929,
        democrat: 47.45,
        republican: 48.75
      },
      AR: {
        total: 837582,
        democrat: 47.52,
        republican: 48.13
      },
      AZ: {
        total: 873945,
        democrat: 28.24,
        republican: 60.61
      },
      CA: {
        total: 8582938,
        democrat: 35.92,
        republican: 52.7
      },
      CO: {
        total: 1184450,
        democrat: 31.07,
        republican: 55.07
      },
      CT: {
        total: 1406285,
        democrat: 38.52,
        republican: 48.16
      },
      DC: {
        total: 173889,
        democrat: 74.89,
        republican: 13.41
      },
      DE: {
        total: 235668,
        democrat: 44.87,
        republican: 47.21
      },
      FL: {
        total: 3686927,
        democrat: 38.5,
        republican: 55.52
      },
      GA: {
        total: 1596805,
        democrat: 55.8,
        republican: 40.97
      },
      HI: {
        total: 303287,
        democrat: 44.8,
        republican: 42.9
      },
      IA: {
        total: 1317661,
        democrat: 38.6,
        republican: 51.31
      },
      ID: {
        total: 437431,
        democrat: 25.19,
        republican: 66.46
      },
      IL: {
        total: 4749721,
        democrat: 41.72,
        republican: 49.65
      },
      IN: {
        total: 2242033,
        democrat: 37.65,
        republican: 56.01
      },
      KS: {
        total: 979795,
        democrat: 33.29,
        republican: 57.85
      },
      KY: {
        total: 1295627,
        democrat: 47.65,
        republican: 49.03
      },
      LA: {
        total: 1548591,
        democrat: 45.75,
        republican: 51.2
      },
      MA: {
        total: 2524090,
        democrat: 41.75,
        republican: 41.9
      },
      MD: {
        total: 1540496,
        democrat: 47.14,
        republican: 44.18
      },
      ME: {
        total: 523011,
        democrat: 42.25,
        republican: 45.61
      },
      MI: {
        total: 3909725,
        democrat: 42.5,
        republican: 48.99
      },
      MN: {
        total: 2051916,
        democrat: 46.5,
        republican: 42.56
      },
      MO: {
        total: 2099824,
        democrat: 44.35,
        republican: 51.16
      },
      MS: {
        total: 891750,
        democrat: 48.14,
        republican: 49.46
      },
      MT: {
        total: 363952,
        democrat: 32.43,
        republican: 56.82
      },
      NC: {
        total: 1855833,
        democrat: 47.18,
        republican: 49.3
      },
      ND: {
        total: 301116,
        democrat: 26.3,
        republican: 64.33
      },
      NE: {
        total: 639533,
        democrat: 26.02,
        republican: 65.55
      },
      NH: {
        total: 383990,
        democrat: 28.35,
        republican: 57.74
      },
      NJ: {
        total: 2975684,
        democrat: 38.56,
        republican: 51.97
      },
      NM: {
        total: 456237,
        democrat: 36.78,
        republican: 54.97
      },
      NV: {
        total: 243692,
        democrat: 27.36,
        republican: 63.61
      },
      NY: {
        total: 6201959,
        democrat: 43.99,
        republican: 42.53
      },
      OH: {
        total: 4283603,
        democrat: 40.91,
        republican: 51.51
      },
      OK: {
        total: 1149708,
        democrat: 34.97,
        republican: 60.5
      },
      OR: {
        total: 1181516,
        democrat: 38.67,
        republican: 48.33
      },
      PA: {
        total: 4561501,
        democrat: 42.48,
        republican: 49.59
      },
      RI: {
        total: 415967,
        democrat: 47.68,
        republican: 37.21
      },
      SC: {
        total: 888258,
        democrat: 48.21,
        republican: 49.45
      },
      SD: {
        total: 327703,
        democrat: 31.69,
        republican: 60.53
      },
      TN: {
        total: 1617616,
        democrat: 48.41,
        republican: 48.7
      },
      TX: {
        total: 4541636,
        democrat: 41.42,
        republican: 55.28
      },
      UT: {
        total: 604152,
        democrat: 20.57,
        republican: 72.78
      },
      VA: {
        total: 1866032,
        democrat: 40.31,
        republican: 53.03
      },
      VT: {
        total: 213299,
        democrat: 38.42,
        republican: 44.36
      },
      WA: {
        total: 1742394,
        democrat: 37.32,
        republican: 49.66
      },
      WI: {
        total: 2273221,
        democrat: 43.18,
        republican: 47.9
      },
      WV: {
        total: 737715,
        democrat: 49.81,
        republican: 45.3
      },
      WY: {
        total: 176713,
        democrat: 27.97,
        republican: 62.64
      }
    },
    1984: {
      AK: {
        total: 207605,
        democrat: 29.87,
        republican: 66.65
      },
      AL: {
        total: 1441713,
        democrat: 38.28,
        republican: 60.54
      },
      AR: {
        total: 884406,
        democrat: 38.29,
        republican: 60.47
      },
      AZ: {
        total: 1025897,
        democrat: 32.54,
        republican: 66.42
      },
      CA: {
        total: 9505041,
        democrat: 41.27,
        republican: 57.52
      },
      CO: {
        total: 1295380,
        democrat: 35.12,
        republican: 63.44
      },
      CT: {
        total: 1466900,
        democrat: 38.83,
        republican: 60.73
      },
      DC: {
        total: 211288,
        democrat: 85.38,
        republican: 13.73
      },
      DE: {
        total: 254572,
        democrat: 39.93,
        republican: 59.78
      },
      FL: {
        total: 4180051,
        democrat: 34.66,
        republican: 65.32
      },
      GA: {
        total: 1776103,
        democrat: 39.79,
        republican: 60.17
      },
      HI: {
        total: 335846,
        democrat: 43.82,
        republican: 55.1
      },
      IA: {
        total: 1319805,
        democrat: 45.89,
        republican: 53.27
      },
      ID: {
        total: 411144,
        democrat: 26.39,
        republican: 72.36
      },
      IL: {
        total: 4819088,
        democrat: 43.3,
        republican: 56.17
      },
      IN: {
        total: 2233069,
        democrat: 37.68,
        republican: 61.67
      },
      KS: {
        total: 1021991,
        democrat: 32.6,
        republican: 66.27
      },
      KY: {
        total: 1369345,
        democrat: 39.4,
        republican: 60.01
      },
      LA: {
        total: 1706822,
        democrat: 38.18,
        republican: 60.77
      },
      MA: {
        total: 2559383,
        democrat: 48.43,
        republican: 51.22
      },
      MD: {
        total: 1675873,
        democrat: 47.02,
        republican: 52.51
      },
      ME: {
        total: 553144,
        democrat: 38.78,
        republican: 60.83
      },
      MI: {
        total: 3801658,
        democrat: 40.24,
        republican: 59.23
      },
      MN: {
        total: 2084449,
        democrat: 49.72,
        republican: 49.54
      },
      MO: {
        total: 2122771,
        democrat: 39.98,
        republican: 60.02
      },
      MS: {
        total: 941104,
        democrat: 37.42,
        republican: 61.88
      },
      MT: {
        total: 384377,
        democrat: 38.18,
        republican: 60.47
      },
      NC: {
        total: 2175361,
        democrat: 37.89,
        republican: 61.9
      },
      ND: {
        total: 308971,
        democrat: 33.8,
        republican: 64.84
      },
      NE: {
        total: 652090,
        democrat: 28.81,
        republican: 70.55
      },
      NH: {
        total: 388904,
        democrat: 30.95,
        republican: 68.67
      },
      NJ: {
        total: 3217862,
        democrat: 39.2,
        republican: 60.09
      },
      NM: {
        total: 514370,
        democrat: 39.23,
        republican: 59.7
      },
      NV: {
        total: 282717,
        democrat: 32.42,
        republican: 66.77
      },
      NY: {
        total: 6806810,
        democrat: 44.09,
        republican: 49.61
      },
      OH: {
        total: 4563235,
        democrat: 40.0,
        republican: 58.7
      },
      OK: {
        total: 1255676,
        democrat: 30.67,
        republican: 68.61
      },
      OR: {
        total: 1226527,
        democrat: 43.74,
        republican: 55.91
      },
      PA: {
        total: 4844903,
        democrat: 45.99,
        republican: 53.34
      },
      RI: {
        total: 410489,
        democrat: 48.02,
        republican: 51.67
      },
      SC: {
        total: 968529,
        democrat: 35.57,
        republican: 63.55
      },
      SD: {
        total: 317867,
        democrat: 36.53,
        republican: 63.0
      },
      TN: {
        total: 1711993,
        democrat: 41.57,
        republican: 57.84
      },
      TX: {
        total: 5397571,
        democrat: 36.11,
        republican: 63.61
      },
      UT: {
        total: 629656,
        democrat: 24.68,
        republican: 74.5
      },
      VA: {
        total: 2146635,
        democrat: 37.09,
        republican: 62.29
      },
      VT: {
        total: 234561,
        democrat: 40.81,
        republican: 57.92
      },
      WA: {
        total: 1874910,
        democrat: 42.58,
        republican: 56.09
      },
      WI: {
        total: 2211689,
        democrat: 45.02,
        republican: 54.19
      },
      WV: {
        total: 735742,
        democrat: 44.6,
        republican: 55.11
      },
      WY: {
        total: 188968,
        democrat: 28.24,
        republican: 70.51
      }
    },
    1988: {
      AK: {
        total: 200116,
        democrat: 36.27,
        republican: 59.59
      },
      AL: {
        total: 1378476,
        democrat: 39.86,
        republican: 59.17
      },
      AR: {
        total: 827738,
        democrat: 42.19,
        republican: 56.37
      },
      AZ: {
        total: 1171873,
        democrat: 38.74,
        republican: 59.95
      },
      CA: {
        total: 9887065,
        democrat: 47.56,
        republican: 51.13
      },
      CO: {
        total: 1372394,
        democrat: 45.28,
        republican: 53.06
      },
      CT: {
        total: 1443394,
        democrat: 46.87,
        republican: 51.98
      },
      DC: {
        total: 192877,
        democrat: 82.65,
        republican: 14.3
      },
      DE: {
        total: 249891,
        democrat: 43.48,
        republican: 55.88
      },
      FL: {
        total: 4302313,
        democrat: 38.51,
        republican: 60.87
      },
      GA: {
        total: 1809672,
        democrat: 39.5,
        republican: 59.75
      },
      HI: {
        total: 354461,
        democrat: 54.27,
        republican: 44.75
      },
      IA: {
        total: 1225614,
        democrat: 54.71,
        republican: 44.5
      },
      ID: {
        total: 408968,
        democrat: 36.01,
        republican: 62.08
      },
      IL: {
        total: 4559120,
        democrat: 48.6,
        republican: 50.69
      },
      IN: {
        total: 2168621,
        democrat: 39.69,
        republican: 59.84
      },
      KS: {
        total: 993044,
        democrat: 42.56,
        republican: 55.79
      },
      KY: {
        total: 1322517,
        democrat: 43.88,
        republican: 55.52
      },
      LA: {
        total: 1628202,
        democrat: 44.06,
        republican: 54.27
      },
      MA: {
        total: 2632801,
        democrat: 53.23,
        republican: 45.38
      },
      MD: {
        total: 1714358,
        democrat: 48.2,
        republican: 51.11
      },
      ME: {
        total: 555035,
        democrat: 43.88,
        republican: 55.34
      },
      MI: {
        total: 3669163,
        democrat: 45.67,
        republican: 53.57
      },
      MN: {
        total: 2096790,
        democrat: 52.91,
        republican: 45.9
      },
      MO: {
        total: 2093228,
        democrat: 47.85,
        republican: 51.83
      },
      MS: {
        total: 931527,
        democrat: 39.07,
        republican: 59.89
      },
      MT: {
        total: 365674,
        democrat: 46.2,
        republican: 52.07
      },
      NC: {
        total: 2134370,
        democrat: 41.71,
        republican: 57.97
      },
      ND: {
        total: 297261,
        democrat: 42.97,
        republican: 56.03
      },
      NE: {
        total: 661465,
        democrat: 39.19,
        republican: 60.16
      },
      NH: {
        total: 450525,
        democrat: 36.33,
        republican: 62.49
      },
      NJ: {
        total: 3099553,
        democrat: 42.6,
        republican: 56.24
      },
      NM: {
        total: 521387,
        democrat: 46.89,
        republican: 51.85
      },
      NV: {
        total: 343133,
        democrat: 38.68,
        republican: 60.05
      },
      NY: {
        total: 6485683,
        democrat: 50.19,
        republican: 43.76
      },
      OH: {
        total: 4393585,
        democrat: 44.15,
        republican: 55.0
      },
      OK: {
        total: 1171036,
        democrat: 41.28,
        republican: 57.93
      },
      OR: {
        total: 1201694,
        democrat: 51.28,
        republican: 46.61
      },
      PA: {
        total: 4536251,
        democrat: 48.39,
        republican: 50.7
      },
      RI: {
        total: 404622,
        democrat: 55.64,
        republican: 43.93
      },
      SC: {
        total: 986009,
        democrat: 37.58,
        republican: 61.5
      },
      SD: {
        total: 312991,
        democrat: 46.51,
        republican: 52.85
      },
      TN: {
        total: 1636250,
        democrat: 41.55,
        republican: 57.89
      },
      TX: {
        total: 5427410,
        democrat: 43.35,
        republican: 55.95
      },
      UT: {
        total: 647008,
        democrat: 32.05,
        republican: 66.22
      },
      VA: {
        total: 2191609,
        democrat: 39.23,
        republican: 59.74
      },
      VT: {
        total: 243328,
        democrat: 47.58,
        republican: 51.1
      },
      WA: {
        total: 1865253,
        democrat: 50.05,
        republican: 48.46
      },
      WI: {
        total: 2191608,
        democrat: 51.41,
        republican: 47.8
      },
      WV: {
        total: 653311,
        democrat: 52.2,
        republican: 47.46
      },
      WY: {
        total: 176551,
        democrat: 38.01,
        republican: 60.53
      }
    },
    1992: {
      AK: {
        total: 258506,
        democrat: 30.29,
        republican: 39.46
      },
      AL: {
        total: 1688060,
        democrat: 40.88,
        republican: 47.65
      },
      AR: {
        total: 950653,
        democrat: 53.21,
        republican: 35.48
      },
      AZ: {
        total: 1486975,
        democrat: 36.52,
        republican: 38.47
      },
      CA: {
        total: 11131721,
        democrat: 46.01,
        republican: 32.61
      },
      CO: {
        total: 1569180,
        democrat: 40.13,
        republican: 35.87
      },
      CT: {
        total: 1616156,
        democrat: 42.22,
        republican: 35.78
      },
      DC: {
        total: 227572,
        democrat: 84.64,
        republican: 9.1
      },
      DE: {
        total: 289620,
        democrat: 43.52,
        republican: 35.33
      },
      FL: {
        total: 5313392,
        democrat: 38.99,
        republican: 40.9
      },
      GA: {
        total: 2321133,
        democrat: 43.47,
        republican: 42.88
      },
      HI: {
        total: 372842,
        democrat: 48.09,
        republican: 36.7
      },
      IA: {
        total: 1354607,
        democrat: 43.29,
        republican: 37.27
      },
      ID: {
        total: 482114,
        democrat: 28.42,
        republican: 42.03
      },
      IL: {
        total: 5050157,
        democrat: 48.58,
        republican: 34.34
      },
      IN: {
        total: 2305871,
        democrat: 36.79,
        republican: 42.91
      },
      KS: {
        total: 1157236,
        democrat: 33.74,
        republican: 38.88
      },
      KY: {
        total: 1492900,
        democrat: 44.55,
        republican: 41.34
      },
      LA: {
        total: 1790017,
        democrat: 45.58,
        republican: 40.97
      },
      MA: {
        total: 2773664,
        democrat: 47.54,
        republican: 29.02
      },
      MD: {
        total: 1984580,
        democrat: 49.81,
        republican: 35.63
      },
      ME: {
        total: 679499,
        democrat: 38.77,
        republican: 30.39
      },
      MI: {
        total: 4274673,
        democrat: 43.77,
        republican: 36.38
      },
      MN: {
        total: 2347948,
        democrat: 43.48,
        republican: 31.85
      },
      MO: {
        total: 2391270,
        democrat: 44.07,
        republican: 33.92
      },
      MS: {
        total: 981793,
        democrat: 40.77,
        republican: 49.68
      },
      MT: {
        total: 410583,
        democrat: 37.63,
        republican: 35.12
      },
      NC: {
        total: 2611850,
        democrat: 42.65,
        republican: 43.44
      },
      ND: {
        total: 308133,
        democrat: 32.18,
        republican: 44.22
      },
      NE: {
        total: 737546,
        democrat: 29.4,
        republican: 46.6
      },
      NH: {
        total: 537215,
        democrat: 38.91,
        republican: 37.69
      },
      NJ: {
        total: 3343594,
        democrat: 42.95,
        republican: 40.58
      },
      NM: {
        total: 569986,
        democrat: 45.9,
        republican: 37.34
      },
      NV: {
        total: 506318,
        democrat: 37.36,
        republican: 34.73
      },
      NY: {
        total: 7079432,
        democrat: 47.28,
        republican: 28.84
      },
      OH: {
        total: 4939967,
        democrat: 40.18,
        republican: 38.35
      },
      OK: {
        total: 1390359,
        democrat: 34.02,
        republican: 42.65
      },
      OR: {
        total: 1462643,
        democrat: 42.48,
        republican: 32.53
      },
      PA: {
        total: 4959810,
        democrat: 45.15,
        republican: 36.13
      },
      RI: {
        total: 453365,
        democrat: 47.05,
        republican: 29.03
      },
      SC: {
        total: 1228912,
        democrat: 42.76,
        republican: 46.99
      },
      SD: {
        total: 336254,
        democrat: 37.14,
        republican: 40.66
      },
      TN: {
        total: 1982638,
        democrat: 47.08,
        republican: 42.43
      },
      TX: {
        total: 6154018,
        democrat: 37.08,
        republican: 40.56
      },
      UT: {
        total: 743998,
        democrat: 24.65,
        republican: 43.36
      },
      VA: {
        total: 2559129,
        democrat: 40.59,
        republican: 44.96
      },
      VT: {
        total: 289701,
        democrat: 46.11,
        republican: 30.42
      },
      WA: {
        total: 2287565,
        democrat: 43.41,
        republican: 31.97
      },
      WI: {
        total: 2531064,
        democrat: 41.13,
        republican: 36.78
      },
      WV: {
        total: 683677,
        democrat: 48.41,
        republican: 35.39
      },
      WY: {
        total: 199884,
        democrat: 34.1,
        republican: 39.7
      }
    },
    1996: {
      AK: {
        total: 241620,
        democrat: 33.27,
        republican: 50.8
      },
      AL: {
        total: 1534349,
        democrat: 43.16,
        republican: 50.12
      },
      AR: {
        total: 884262,
        democrat: 53.74,
        republican: 36.8
      },
      AZ: {
        total: 1404405,
        democrat: 46.52,
        republican: 44.29
      },
      CA: {
        total: 10019469,
        democrat: 51.1,
        republican: 38.21
      },
      CO: {
        total: 1510702,
        democrat: 44.43,
        republican: 45.8
      },
      CT: {
        total: 1392614,
        democrat: 52.83,
        republican: 34.69
      },
      DC: {
        total: 185726,
        democrat: 85.19,
        republican: 9.34
      },
      DE: {
        total: 270810,
        democrat: 51.83,
        republican: 36.58
      },
      FL: {
        total: 5303154,
        democrat: 48.03,
        republican: 42.32
      },
      GA: {
        total: 2298899,
        democrat: 45.84,
        republican: 47.02
      },
      HI: {
        total: 360120,
        democrat: 56.93,
        republican: 31.64
      },
      IA: {
        total: 1234075,
        democrat: 50.26,
        republican: 39.92
      },
      ID: {
        total: 491711,
        democrat: 33.65,
        republican: 52.18
      },
      IL: {
        total: 4311391,
        democrat: 54.32,
        republican: 36.81
      },
      IN: {
        total: 2135431,
        democrat: 41.56,
        republican: 47.14
      },
      KS: {
        total: 1074300,
        democrat: 36.08,
        republican: 54.29
      },
      KY: {
        total: 1388708,
        democrat: 45.84,
        republican: 44.88
      },
      LA: {
        total: 1783959,
        democrat: 52.01,
        republican: 39.94
      },
      MA: {
        total: 2556459,
        democrat: 61.47,
        republican: 28.09
      },
      MD: {
        total: 1780870,
        democrat: 54.25,
        republican: 38.27
      },
      ME: {
        total: 605897,
        democrat: 51.62,
        republican: 30.76
      },
      MI: {
        total: 3848844,
        democrat: 51.69,
        republican: 38.48
      },
      MN: {
        total: 2192492,
        democrat: 51.1,
        republican: 34.96
      },
      MO: {
        total: 2158065,
        democrat: 47.54,
        republican: 41.24
      },
      MS: {
        total: 893857,
        democrat: 44.08,
        republican: 49.21
      },
      MT: {
        total: 407083,
        democrat: 41.25,
        republican: 44.13
      },
      NC: {
        total: 2515807,
        democrat: 44.04,
        republican: 48.73
      },
      ND: {
        total: 266411,
        democrat: 40.13,
        republican: 46.94
      },
      NE: {
        total: 677415,
        democrat: 34.95,
        republican: 53.65
      },
      NH: {
        total: 496597,
        democrat: 49.57,
        republican: 39.57
      },
      NJ: {
        total: 3075860,
        democrat: 53.72,
        republican: 35.86
      },
      NM: {
        total: 556074,
        democrat: 49.18,
        republican: 41.86
      },
      NV: {
        total: 464279,
        democrat: 43.93,
        republican: 42.91
      },
      NY: {
        total: 6439129,
        democrat: 56.68,
        republican: 27.0
      },
      OH: {
        total: 4534434,
        democrat: 47.38,
        republican: 41.02
      },
      OK: {
        total: 1206713,
        democrat: 40.45,
        republican: 48.26
      },
      OR: {
        total: 1377760,
        democrat: 47.15,
        republican: 39.06
      },
      PA: {
        total: 4501307,
        democrat: 49.23,
        republican: 40.01
      },
      RI: {
        total: 390247,
        democrat: 59.72,
        republican: 26.82
      },
      SC: {
        total: 1150182,
        democrat: 44.01,
        republican: 49.85
      },
      SD: {
        total: 323826,
        democrat: 43.03,
        republican: 46.49
      },
      TN: {
        total: 1894105,
        democrat: 48.0,
        republican: 45.59
      },
      TX: {
        total: 5611644,
        democrat: 43.83,
        republican: 48.76
      },
      UT: {
        total: 665629,
        democrat: 33.3,
        republican: 54.37
      },
      VA: {
        total: 2416642,
        democrat: 45.15,
        republican: 47.1
      },
      VT: {
        total: 258449,
        democrat: 53.35,
        republican: 31.09
      },
      WA: {
        total: 2253837,
        democrat: 49.84,
        republican: 37.3
      },
      WI: {
        total: 2196169,
        democrat: 48.81,
        republican: 38.48
      },
      WV: {
        total: 636459,
        democrat: 51.51,
        republican: 36.76
      },
      WY: {
        total: 211571,
        democrat: 36.84,
        republican: 49.81
      }
    },
    2000: {
      AK: {
        total: 285560,
        democrat: 27.67,
        republican: 58.62
      },
      AL: {
        total: 1666272,
        democrat: 41.57,
        republican: 56.48
      },
      AR: {
        total: 921781,
        democrat: 45.86,
        republican: 51.31
      },
      AZ: {
        total: 1532016,
        democrat: 44.73,
        republican: 51.02
      },
      CA: {
        total: 10965822,
        democrat: 53.45,
        republican: 41.65
      },
      CO: {
        total: 1741368,
        democrat: 42.39,
        republican: 50.75
      },
      CT: {
        total: 1459525,
        democrat: 55.91,
        republican: 38.44
      },
      DC: {
        total: 201894,
        democrat: 85.16,
        republican: 8.95
      },
      DE: {
        total: 327529,
        democrat: 54.98,
        republican: 41.92
      },
      FL: {
        total: 5963110,
        democrat: 48.84,
        republican: 48.85
      },
      GA: {
        total: 2583208,
        democrat: 43.21,
        republican: 54.96
      },
      HI: {
        total: 367951,
        democrat: 55.79,
        republican: 37.46
      },
      IA: {
        total: 1353022,
        democrat: 47.19,
        republican: 46.89
      },
      ID: {
        total: 501615,
        democrat: 27.64,
        republican: 67.17
      },
      IL: {
        total: 4742108,
        democrat: 54.6,
        republican: 42.58
      },
      IN: {
        total: 2199302,
        democrat: 41.01,
        republican: 56.65
      },
      KS: {
        total: 1072216,
        democrat: 37.24,
        republican: 58.04
      },
      KY: {
        total: 1544106,
        democrat: 41.38,
        republican: 56.51
      },
      LA: {
        total: 1765656,
        democrat: 44.88,
        republican: 52.55
      },
      MA: {
        total: 2733964,
        democrat: 59.13,
        republican: 32.13
      },
      MD: {
        total: 2025212,
        democrat: 56.49,
        republican: 40.18
      },
      ME: {
        total: 651817,
        democrat: 49.09,
        republican: 43.97
      },
      MI: {
        total: 4232501,
        democrat: 51.28,
        republican: 46.15
      },
      MN: {
        total: 2438685,
        republican: 45.5
      },
      MO: {
        total: 2359892,
        democrat: 47.08,
        republican: 50.42
      },
      MS: {
        total: 994184,
        democrat: 40.7,
        republican: 57.62
      },
      MT: {
        total: 410986,
        democrat: 33.37,
        republican: 58.44
      },
      NC: {
        total: 2914990,
        democrat: 43.15,
        republican: 55.96
      },
      ND: {
        total: 288256,
        democrat: 33.06,
        republican: 60.66
      },
      NE: {
        total: 697019,
        democrat: 33.25,
        republican: 62.25
      },
      NH: {
        total: 569081,
        democrat: 46.8,
        republican: 48.07
      },
      NJ: {
        total: 3187226,
        democrat: 56.13,
        republican: 40.29
      },
      NM: {
        total: 598605,
        democrat: 47.91,
        republican: 47.85
      },
      NV: {
        total: 609426,
        democrat: 45.94,
        republican: 49.49
      },
      NY: {
        total: 6960215,
        democrat: 56.64,
        republican: 32.45
      },
      OH: {
        total: 4701998,
        democrat: 46.44,
        republican: 49.99
      },
      OK: {
        total: 1234229,
        democrat: 38.43,
        republican: 60.31
      },
      OR: {
        total: 1533950,
        democrat: 46.96,
        republican: 46.52
      },
      PA: {
        total: 4912185,
        democrat: 50.61,
        republican: 46.44
      },
      RI: {
        total: 409112,
        democrat: 60.99,
        republican: 31.91
      },
      SC: {
        total: 1383902,
        democrat: 40.9,
        republican: 56.86
      },
      SD: {
        total: 316269,
        democrat: 37.56,
        republican: 60.3
      },
      TN: {
        total: 2076181,
        democrat: 47.28,
        republican: 51.15
      },
      TX: {
        total: 6407637,
        democrat: 37.98,
        republican: 59.3
      },
      UT: {
        total: 770754,
        democrat: 26.34,
        republican: 66.83
      },
      VA: {
        total: 2739447,
        democrat: 44.44,
        republican: 52.47
      },
      VT: {
        total: 294308,
        democrat: 50.63,
        republican: 40.7
      },
      WA: {
        total: 2487433,
        democrat: 50.16,
        republican: 44.58
      },
      WI: {
        total: 2598607,
        democrat: 47.83,
        republican: 47.61
      },
      WV: {
        total: 648124,
        democrat: 45.59,
        republican: 51.92
      },
      WY: {
        total: 213726,
        democrat: 28.3,
        republican: 69.22
      }
    },
    2004: {
      AK: {
        total: 312598,
        democrat: 35.52,
        republican: 61.07
      },
      AL: {
        total: 1883415,
        democrat: 36.84,
        republican: 62.46
      },
      AR: {
        total: 1054945,
        democrat: 44.55,
        republican: 54.31
      },
      AZ: {
        total: 2012585,
        democrat: 44.4,
        republican: 54.87
      },
      CA: {
        total: 12421353,
        democrat: 54.31,
        republican: 44.36
      },
      CO: {
        total: 2129630,
        democrat: 47.04,
        republican: 51.71
      },
      CT: {
        total: 1578769,
        democrat: 54.31,
        republican: 43.95
      },
      DC: {
        total: 227586,
        democrat: 89.18,
        republican: 9.34
      },
      DE: {
        total: 375190,
        democrat: 53.35,
        republican: 45.75
      },
      FL: {
        total: 7609810,
        democrat: 47.09,
        republican: 52.1
      },
      GA: {
        total: 3301875,
        democrat: 41.37,
        republican: 57.97
      },
      HI: {
        total: 429013,
        democrat: 54.01,
        republican: 45.26
      },
      IA: {
        total: 1506908,
        democrat: 49.23,
        republican: 49.9
      },
      ID: {
        total: 598376,
        democrat: 30.26,
        republican: 68.39
      },
      IL: {
        total: 5274322,
        democrat: 54.82,
        republican: 44.48
      },
      IN: {
        total: 2468002,
        democrat: 39.26,
        republican: 59.94
      },
      KS: {
        total: 1187756,
        democrat: 36.62,
        republican: 62.0
      },
      KY: {
        total: 1795882,
        democrat: 39.69,
        republican: 59.55
      },
      LA: {
        total: 1943106,
        democrat: 42.22,
        republican: 56.72
      },
      MA: {
        total: 2927455,
        democrat: 61.62,
        republican: 36.59
      },
      MD: {
        total: 2384238,
        democrat: 55.97,
        republican: 42.98
      },
      ME: {
        total: 740752,
        democrat: 53.57,
        republican: 44.58
      },
      MI: {
        total: 4839252,
        democrat: 51.23,
        republican: 47.81
      },
      MN: {
        total: 2828387,
        republican: 47.61
      },
      MO: {
        total: 2731364,
        democrat: 46.1,
        republican: 53.3
      },
      MS: {
        total: 1139824,
        democrat: 40.16,
        republican: 59.01
      },
      MT: {
        total: 450434,
        democrat: 38.57,
        republican: 59.07
      },
      NC: {
        total: 3501007,
        democrat: 43.58,
        republican: 56.02
      },
      ND: {
        total: 312833,
        democrat: 35.5,
        republican: 62.86
      },
      NE: {
        total: 778186,
        democrat: 32.68,
        republican: 65.9
      },
      NH: {
        total: 678287,
        democrat: 50.2,
        republican: 48.83
      },
      NJ: {
        total: 3611691,
        democrat: 52.92,
        republican: 46.24
      },
      NM: {
        total: 756304,
        democrat: 49.05,
        republican: 49.84
      },
      NV: {
        total: 829587,
        democrat: 47.88,
        republican: 50.47
      },
      NY: {
        total: 7448266,
        democrat: 56.13,
        republican: 37.69
      },
      OH: {
        total: 5627903,
        democrat: 48.71,
        republican: 50.81
      },
      OK: {
        total: 1463758,
        democrat: 34.43,
        republican: 65.57
      },
      OR: {
        total: 1836782,
        democrat: 51.35,
        republican: 47.19
      },
      PA: {
        total: 5769590,
        democrat: 50.92,
        republican: 48.42
      },
      RI: {
        total: 437134,
        democrat: 59.42,
        republican: 38.67
      },
      SC: {
        total: 1617700,
        democrat: 40.9,
        republican: 57.98
      },
      SD: {
        total: 388215,
        democrat: 38.44,
        republican: 59.91
      },
      TN: {
        total: 2437319,
        democrat: 42.53,
        republican: 56.8
      },
      TX: {
        total: 7410749,
        democrat: 38.22,
        republican: 61.09
      },
      UT: {
        total: 927844,
        democrat: 26.0,
        republican: 71.54
      },
      VA: {
        total: 3195415,
        democrat: 45.53,
        republican: 53.73
      },
      VT: {
        total: 312309,
        democrat: 58.94,
        republican: 38.8
      },
      WA: {
        total: 2859084,
        democrat: 52.82,
        republican: 45.64
      },
      WI: {
        total: 2997007,
        democrat: 49.7,
        republican: 49.32
      },
      WV: {
        total: 755792,
        democrat: 43.21,
        republican: 56.07
      },
      WY: {
        total: 243861,
        democrat: 29.02,
        republican: 68.74
      }
    },
    2008: {
      AK: {
        total: 326197,
        democrat: 37.89,
        republican: 59.42
      },
      AL: {
        total: 2099819,
        democrat: 38.74,
        republican: 60.32
      },
      AR: {
        total: 1086617,
        democrat: 38.86,
        republican: 58.72
      },
      AZ: {
        total: 2293475,
        democrat: 45.12,
        republican: 53.64
      },
      CA: {
        total: 13561900,
        democrat: 61.01,
        republican: 36.95
      },
      CO: {
        total: 2401361,
        democrat: 53.66,
        republican: 44.71
      },
      CT: {
        total: 1646792,
        democrat: 60.59,
        republican: 38.22
      },
      DC: {
        total: 265853,
        democrat: 92.46,
        republican: 6.53
      },
      DE: {
        total: 412412,
        democrat: 61.94,
        republican: 36.95
      },
      FL: {
        total: 8390744,
        democrat: 51.03,
        republican: 48.22
      },
      GA: {
        total: 3924486,
        democrat: 46.99,
        republican: 52.2
      },
      HI: {
        total: 456064,
        democrat: 71.45,
        republican: 26.44
      },
      IA: {
        total: 1537123,
        democrat: 53.93,
        republican: 44.39
      },
      ID: {
        total: 655122,
        democrat: 36.09,
        republican: 61.52
      },
      IL: {
        total: 5522371,
        democrat: 61.92,
        republican: 36.78
      },
      IN: {
        total: 2751054,
        democrat: 49.95,
        republican: 48.91
      },
      KS: {
        total: 1235872,
        democrat: 41.65,
        republican: 56.61
      },
      KY: {
        total: 1826620,
        democrat: 41.17,
        republican: 57.4
      },
      LA: {
        total: 1960761,
        democrat: 39.93,
        republican: 58.56
      },
      MA: {
        total: 3102995,
        democrat: 61.36,
        republican: 35.73
      },
      MD: {
        total: 2631596,
        democrat: 61.92,
        republican: 36.47
      },
      ME: {
        total: 731163,
        democrat: 57.71,
        republican: 40.38
      },
      MI: {
        total: 5001596,
        democrat: 57.43,
        republican: 40.96
      },
      MN: {
        total: 2910369,
        democrat: 54.06,
        republican: 43.82
      },
      MO: {
        total: 2925205,
        democrat: 49.29,
        republican: 49.43
      },
      MS: {
        total: 1289865,
        democrat: 43.0,
        republican: 56.18
      },
      MT: {
        total: 490109,
        democrat: 47.27,
        republican: 49.53
      },
      NC: {
        total: 4310851,
        democrat: 49.7,
        republican: 49.37
      },
      ND: {
        total: 316621,
        democrat: 44.62,
        republican: 53.25
      },
      NE: {
        total: 801281,
        democrat: 41.6,
        republican: 56.53
      },
      NH: {
        total: 710970,
        democrat: 54.13,
        republican: 44.52
      },
      NJ: {
        total: 3868237,
        democrat: 57.27,
        republican: 41.7
      },
      NM: {
        total: 830158,
        democrat: 56.91,
        republican: 41.78
      },
      NV: {
        total: 967848,
        democrat: 55.15,
        republican: 42.65
      },
      NY: {
        total: 7722019,
        democrat: 60.16,
        republican: 31.32
      },
      OH: {
        total: 5708350,
        democrat: 51.5,
        republican: 46.91
      },
      OK: {
        total: 1462661,
        democrat: 34.35,
        republican: 65.65
      },
      OR: {
        total: 1827864,
        democrat: 56.75,
        republican: 40.4
      },
      PA: {
        total: 6013272,
        democrat: 54.49,
        republican: 44.17
      },
      RI: {
        total: 471766,
        democrat: 62.86,
        republican: 35.06
      },
      SC: {
        total: 1920969,
        democrat: 44.9,
        republican: 53.87
      },
      SD: {
        total: 381975,
        democrat: 44.75,
        republican: 53.16
      },
      TN: {
        total: 2599749,
        democrat: 41.83,
        republican: 56.9
      },
      TX: {
        total: 8077795,
        democrat: 43.68,
        republican: 55.45
      },
      UT: {
        total: 952370,
        democrat: 34.41,
        republican: 62.58
      },
      VA: {
        total: 3723260,
        democrat: 52.63,
        republican: 46.33
      },
      VT: {
        total: 325046,
        democrat: 67.46,
        republican: 30.45
      },
      WA: {
        total: 3036878,
        democrat: 57.65,
        republican: 40.48
      },
      WI: {
        total: 2983417,
        democrat: 56.22,
        republican: 42.31
      },
      WV: {
        total: 713451,
        democrat: 42.59,
        republican: 55.71
      },
      WY: {
        total: 254904,
        democrat: 32.51,
        republican: 64.71
      }
    },
    2012: {
      AK: {
        total: 300495,
        democrat: 40.81,
        republican: 54.8
      },
      AL: {
        total: 2074338,
        democrat: 38.36,
        republican: 60.55
      },
      AR: {
        total: 1069468,
        democrat: 36.88,
        republican: 60.57
      },
      AZ: {
        total: 2299254,
        democrat: 44.59,
        republican: 53.65
      },
      CA: {
        total: 13038547,
        democrat: 60.24,
        republican: 37.12
      },
      CO: {
        total: 2569516,
        democrat: 51.49,
        republican: 46.13
      },
      CT: {
        total: 1558204,
        democrat: 58.09,
        republican: 40.75
      },
      DC: {
        total: 293764,
        democrat: 90.91,
        republican: 7.28
      },
      DE: {
        total: 413890,
        democrat: 58.61,
        republican: 39.98
      },
      FL: {
        total: 8474179,
        democrat: 50.01,
        republican: 49.13
      },
      GA: {
        total: 3897839,
        democrat: 45.51,
        republican: 53.33
      },
      HI: {
        total: 437159,
        democrat: 70.15,
        republican: 27.68
      },
      IA: {
        total: 1582180,
        democrat: 51.99,
        republican: 46.18
      },
      ID: {
        total: 652274,
        democrat: 32.62,
        republican: 64.53
      },
      IL: {
        total: 5242014,
        democrat: 57.6,
        republican: 40.73
      },
      IN: {
        total: 2624534,
        democrat: 43.93,
        republican: 54.13
      },
      KS: {
        total: 1159971,
        democrat: 37.99,
        republican: 59.71
      },
      KY: {
        total: 1797212,
        democrat: 37.8,
        republican: 60.49
      },
      LA: {
        total: 1994065,
        democrat: 40.58,
        republican: 57.78
      },
      MA: {
        total: 3184196,
        democrat: 60.34,
        republican: 37.32
      },
      MD: {
        total: 2707327,
        democrat: 61.97,
        republican: 35.9
      },
      ME: {
        total: 724758,
        democrat: 55.37,
        republican: 40.33
      },
      MI: {
        total: 4730961,
        democrat: 54.21,
        republican: 44.71
      },
      MN: {
        total: 2936561,
        republican: 44.96
      },
      MO: {
        total: 2757323,
        democrat: 44.38,
        republican: 53.76
      },
      MS: {
        total: 1285584,
        democrat: 43.79,
        republican: 55.29
      },
      MT: {
        total: 484048,
        democrat: 41.7,
        republican: 55.35
      },
      NC: {
        total: 4505372,
        democrat: 48.35,
        republican: 50.39
      },
      ND: {
        total: 322932,
        democrat: 38.7,
        republican: 58.32
      },
      NE: {
        total: 794379,
        democrat: 38.03,
        republican: 59.8
      },
      NH: {
        total: 710972,
        democrat: 51.98,
        republican: 46.4
      },
      NJ: {
        total: 3638499,
        democrat: 58.34,
        republican: 40.62
      },
      NM: {
        total: 783758,
        democrat: 52.99,
        republican: 42.84
      },
      NV: {
        total: 1014918,
        democrat: 52.36,
        republican: 45.68
      },
      NY: {
        total: 7116784,
        democrat: 60.76,
        republican: 31.24
      },
      OH: {
        total: 5580822,
        democrat: 50.67,
        republican: 47.69
      },
      OK: {
        total: 1334872,
        democrat: 33.23,
        republican: 66.77
      },
      OR: {
        total: 1789270,
        democrat: 54.24,
        republican: 42.15
      },
      PA: {
        total: 5742040,
        democrat: 52.08,
        republican: 46.68
      },
      RI: {
        total: 446049,
        democrat: 62.7,
        republican: 35.24
      },
      SC: {
        total: 1964118,
        democrat: 44.09,
        republican: 54.56
      },
      SD: {
        total: 363815,
        democrat: 39.87,
        republican: 57.89
      },
      TN: {
        total: 2458577,
        democrat: 39.08,
        republican: 59.48
      },
      TX: {
        total: 7993851,
        democrat: 41.38,
        republican: 57.17
      },
      UT: {
        total: 1017440,
        democrat: 24.75,
        republican: 72.79
      },
      VA: {
        total: 3854489,
        democrat: 51.16,
        republican: 47.28
      },
      VT: {
        total: 299290,
        democrat: 66.57,
        republican: 30.97
      },
      WA: {
        total: 3125516,
        democrat: 56.16,
        republican: 41.29
      },
      WI: {
        total: 3071434,
        democrat: 52.78,
        republican: 45.94
      },
      WV: {
        total: 670438,
        democrat: 35.54,
        republican: 62.3
      },
      WY: {
        total: 250701,
        democrat: 27.64,
        republican: 68.19
      }
    },
    2016: {
      AK: {
        total: 318608,
        democrat: 36.55,
        republican: 51.28
      },
      AL: {
        total: 2123372,
        democrat: 34.36,
        republican: 62.08
      },
      AR: {
        total: 1130635,
        democrat: 33.65,
        republican: 60.57
      },
      AZ: {
        total: 2573165,
        democrat: 45.13,
        republican: 48.67
      },
      CA: {
        total: 14181595,
        democrat: 61.73,
        republican: 31.62
      },
      CO: {
        total: 2780220,
        democrat: 48.16,
        republican: 43.25
      },
      CT: {
        total: 1644920,
        democrat: 54.57,
        republican: 40.93
      },
      DC: {
        total: 312575,
        democrat: 90.48,
        republican: 4.07
      },
      DE: {
        total: 441590,
        democrat: 53.35,
        republican: 41.92
      },
      FL: {
        total: 9420039,
        democrat: 47.82,
        republican: 49.02
      },
      GA: {
        total: 4114732,
        democrat: 45.64,
        republican: 50.77
      },
      HI: {
        total: 437664,
        democrat: 60.98,
        republican: 29.44
      },
      IA: {
        total: 1565580,
        democrat: 41.75,
        republican: 51.16
      },
      ID: {
        total: 690255,
        democrat: 27.49,
        republican: 59.26
      },
      IL: {
        total: 5536424,
        democrat: 55.83,
        republican: 38.76
      },
      IN: {
        total: 2734958,
        democrat: 37.77,
        republican: 56.94
      },
      KS: {
        total: 1184402,
        democrat: 36.05,
        republican: 56.65
      },
      KY: {
        total: 1924149,
        democrat: 32.68,
        republican: 62.52
      },
      LA: {
        total: 2029032,
        democrat: 38.45,
        republican: 58.09
      },
      MA: {
        total: 3378821,
        democrat: 59.05,
        republican: 32.29
      },
      MD: {
        total: 2781446,
        democrat: 60.33,
        republican: 33.919999999999995
      },
      ME: {
        total: 771892,
        democrat: 46.35,
        republican: 43.48
      },
      MI: {
        total: 4799284,
        democrat: 47.27,
        republican: 47.5
      },
      MN: {
        total: 2944782,
        democrat: 46.45,
        republican: 44.93
      },
      MO: {
        total: 2808605,
        democrat: 38.14,
        republican: 56.77
      },
      MS: {
        total: 1209357,
        democrat: 40.11,
        republican: 57.94
      },
      MT: {
        total: 494526,
        democrat: 35.94,
        republican: 56.47
      },
      NC: {
        total: 4741564,
        democrat: 46.17,
        republican: 49.83
      },
      ND: {
        total: 344360,
        democrat: 27.23,
        republican: 62.96
      },
      NE: {
        total: 844227,
        democrat: 33.7,
        republican: 58.75
      },
      NH: {
        total: 744296,
        democrat: 46.83,
        republican: 46.46
      },
      NJ: {
        total: 3874046,
        democrat: 55.45,
        republican: 41.35
      },
      NM: {
        total: 798319,
        democrat: 48.26,
        republican: 40.04
      },
      NV: {
        total: 1125385,
        democrat: 47.92,
        republican: 45.5
      },
      NY: {
        total: 7802084,
        democrat: 56.14,
        republican: 32.39
      },
      OH: {
        total: 5496487,
        democrat: 43.56,
        republican: 51.69
      },
      OK: {
        total: 1452992,
        democrat: 28.93,
        republican: 65.32
      },
      OR: {
        total: 2001336,
        democrat: 50.07,
        republican: 39.09
      },
      PA: {
        total: 6115402,
        democrat: 47.85,
        republican: 48.58
      },
      RI: {
        total: 464144,
        democrat: 54.41,
        republican: 38.9
      },
      SC: {
        total: 2103027,
        democrat: 40.67,
        republican: 54.94
      },
      SD: {
        total: 370093,
        democrat: 31.74,
        republican: 61.53
      },
      TN: {
        total: 2508027,
        democrat: 34.72,
        republican: 60.72
      },
      TX: {
        total: 8969226,
        democrat: 43.24,
        republican: 52.23
      },
      UT: {
        total: 1131317,
        democrat: 27.46,
        republican: 45.54
      },
      VA: {
        total: 3982752,
        democrat: 49.75,
        republican: 44.43
      },
      VT: {
        total: 320467,
        democrat: 55.72,
        republican: 29.76
      },
      WA: {
        total: 3317019,
        democrat: 52.54,
        republican: 36.83
      },
      WI: {
        total: 2976150,
        democrat: 46.45,
        republican: 47.22
      },
      WV: {
        total: 713051,
        democrat: 26.48,
        republican: 68.63
      },
      WY: {
        total: 258788,
        democrat: 21.63,
        republican: 67.4
      }
    },
    2020: {
      AK: {
        total: 359530,
        democrat: 42.77,
        republican: 52.83
      },
      AL: {
        total: 2323282,
        democrat: 36.57,
        republican: 62.03
      },
      AR: {
        total: 1219069,
        democrat: 34.78,
        republican: 62.4
      },
      AZ: {
        total: 3387326,
        democrat: 49.36,
        republican: 49.06
      },
      CA: {
        total: 17500881,
        democrat: 63.48,
        republican: 34.32
      },
      CO: {
        total: 3279980,
        democrat: 55.01,
        republican: 41.6
      },
      CT: {
        total: 1823857,
        democrat: 59.26,
        republican: 39.19
      },
      DC: {
        total: 344356,
        democrat: 92.15,
        republican: 5.4
      },
      DE: {
        total: 504346,
        democrat: 58.74,
        republican: 39.77
      },
      FL: {
        total: 11067456,
        democrat: 47.86,
        republican: 51.22
      },
      GA: {
        total: 4999960,
        democrat: 49.47,
        republican: 49.24
      },
      HI: {
        total: 579784,
        democrat: 63.15,
        republican: 33.95
      },
      IA: {
        total: 1700130,
        democrat: 44.65,
        republican: 52.8
      },
      ID: {
        total: 868014,
        democrat: 33.07,
        republican: 63.84
      },
      IL: {
        total: 6033743,
        democrat: 57.54,
        republican: 40.55
      },
      IN: {
        total: 3033118,
        democrat: 40.96,
        republican: 57.02
      },
      KS: {
        total: 1372303,
        democrat: 41.56,
        republican: 56.21
      },
      KY: {
        total: 2136768,
        democrat: 36.15,
        republican: 62.09
      },
      LA: {
        total: 2148062,
        democrat: 39.85,
        republican: 58.46
      },
      MA: {
        total: 3658005,
        democrat: 65.12,
        republican: 31.91
      },
      MD: {
        total: 3037030,
        democrat: 65.36,
        republican: 32.15
      },
      ME: {
        total: 828305,
        democrat: 52.53,
        republican: 43.55
      },
      MI: {
        total: 5539302,
        democrat: 50.62,
        republican: 47.84
      },
      MN: {
        total: 3277171,
        democrat: 52.4,
        republican: 45.28
      },
      MO: {
        total: 3025962,
        democrat: 41.41,
        republican: 56.8
      },
      MS: {
        total: 1313759,
        democrat: 41.06,
        republican: 57.6
      },
      MT: {
        total: 603674,
        democrat: 40.55,
        republican: 56.92
      },
      NC: {
        total: 5524802,
        democrat: 48.59,
        republican: 49.93
      },
      ND: {
        total: 361819,
        democrat: 31.76,
        republican: 65.11
      },
      NE: {
        total: 956383,
        democrat: 39.17,
        republican: 58.22
      },
      NH: {
        total: 806182,
        democrat: 52.71,
        republican: 45.36
      },
      NJ: {
        total: 4549353,
        democrat: 57.33,
        republican: 41.4
      },
      NM: {
        total: 923965,
        democrat: 54.29,
        republican: 43.5
      },
      NV: {
        total: 1405376,
        democrat: 50.06,
        republican: 47.67
      },
      NY: {
        total: 8661735,
        democrat: 60.39,
        republican: 37.46
      },
      OH: {
        total: 5922202,
        democrat: 45.24,
        republican: 53.27
      },
      OK: {
        total: 1560699,
        democrat: 32.29,
        republican: 65.37
      },
      OR: {
        total: 2374321,
        democrat: 56.45,
        republican: 40.37
      },
      PA: {
        total: 6915283,
        democrat: 50.01,
        republican: 48.84
      },
      RI: {
        total: 516990,
        democrat: 59.48,
        republican: 38.67
      },
      SC: {
        total: 2514096,
        democrat: 43.42,
        republican: 55.09
      },
      SD: {
        total: 422609,
        democrat: 35.61,
        republican: 61.77
      },
      TN: {
        total: 3053851,
        democrat: 37.45,
        republican: 60.66
      },
      TX: {
        total: 11315056,
        democrat: 46.48,
        republican: 52.06
      },
      UT: {
        total: 1488289,
        democrat: 37.65,
        republican: 58.13
      },
      VA: {
        total: 4460524,
        democrat: 54.11,
        republican: 44.0
      },
      VT: {
        total: 370968,
        democrat: 65.46,
        republican: 30.38
      },
      WA: {
        total: 4087631,
        democrat: 57.97,
        republican: 38.77
      },
      WI: {
        total: 3298041,
        democrat: 49.45,
        republican: 48.82
      },
      WV: {
        total: 794652,
        democrat: 29.7,
        republican: 68.63
      },
      WY: {
        total: 278503,
        democrat: 26.39,
        republican: 69.5
      }
    }
  }
]

export default electionData;
